import { Component, OnInit } from '@angular/core';
import { CataloguesService } from '../catalogues.service';
import { ModulesService } from '../modules.service';

@Component({
  selector: 'stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.css']
})
export class StatsComponent implements OnInit {
  //private catalogs
  cats: any[] = [];
  catCount: number = 0;
  modules: any[] = [];
  modCount: number = 0;

  //inject services
  constructor(private cs: CataloguesService, private ms: ModulesService) { }

  //initialize the component
  ngOnInit(): void {
    this.cats = this.cs.getCatalogList();
    this.catCount = this.cats.length;
    this.modules = this.ms.getModuleList();
    this.modCount = this.modules.length;
  }

}
